export const periods: { value: number; description: string }[] = [{
    value: 1,
    description: 'Last 1 Day'
}, {
    value: 7,
    description: 'Last 7 Days'
}, {
    value: 14,
    description: 'Last 14 Days'
}, {
    value: 21,
    description: 'Last 21 Days'
}, {
    value: 30,
    description: 'Last 1 Month'
}]